import { COLORS } from '../../constants/theme';
import { Toggle } from '../ui/Toggle';

interface FilterBlockProps {
  label: string;
  enabled: boolean;
  onToggle: (enabled: boolean) => void;
  children: React.ReactNode;
}

export function FilterBlock({ label, enabled, onToggle, children }: FilterBlockProps) {
  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: enabled ? 6 : 0 }}>
        <Toggle enabled={enabled} onChange={() => onToggle(!enabled)} />
        <span style={{
          color: enabled ? COLORS.text.secondary : COLORS.text.muted,
          fontSize: 11,
          fontWeight: 600,
        }}>
          {label}
        </span>
      </div>
      {enabled && (
        <div style={{ animation: 'tf-fadein 0.15s ease-out' }}>
          {children}
        </div>
      )}
    </div>
  );
}
